import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueGtag from "vue-gtag";
import VueYandexMetrika from "vue-yandex-metrika";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { token, expiration } from "./axios";
import Swal from "sweetalert2";
import routes from "./routes/router";
import roles from "./plugins/roles";
import { getNormalizeDate } from "@/service/getNormalizeDate";
import { addCommas, removeCommas } from "@/service/commas";
import { calcDays } from "@/service/calcDays";
import { procent } from "@/service/procent";
import {
  sendToCalc,
  sendToCalcResult,
  setCalcByRegisterBG,
} from "@/service/MyCalculationsTable";
import { addProcentToTable } from "@/service/addProcentToTable";
import { getAvarege } from "@/service/getAvarege";
import { CalculateAvaregeRate } from "@/service/CalculateAvaregeRate";
import { session, genSession } from "@/service/session";
import { correctStr, correctNum } from "@/service/correct";
import { dateToCalendar, calendarToDate } from "@/service/calendarDate";
import { getGarPolzZakActual } from "@/service/getGarPolzZakActual";
import { getClientSituation } from "@/service/getClientSituation";
import { saveReportData } from "@/service/saveReportData";
import { getSelectedTable } from "@/service/getSelectedTable";
import { getAllTable } from "@/service/getAllTable";
import { onlyNumber } from "@/service/onlyNumber";
import { getUsersList } from "@/service/UsersList";
import { checkRole } from "@/service/checkRole";
import { getRoles } from "@/service/getRole";
import { cutTextLength } from "@/service/cutTextLength";
import { getProtocoInfo } from "./service/getProtocolInfo";
import { initUserObjectRating } from "./service/initUserObjectRating";
import { DeepCopy } from "./service/DeepCopy";
import { getEIS } from "./service/getEIS";
import toBoolean from "./service/toBoolean";
import { stringToHash } from "./service/stringToHash";

export const eventBus = new Vue();

import VueTheMask from "vue-the-mask";

// import moment from 'moment';
Vue.use(VueGtag, {
  config: { id: "G-71GZP7TEXY" },
});
Vue.use(VueYandexMetrika, {
  id: 86122118,
  router: router,
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  env: process.env.NODE_ENV,
});

Vue.use(VueTheMask);

Vue.config.productionTip = false;

// localStorage.setItem('LocalProtocols', "No");

window.Fire = new Vue();

window.Swal = Swal;

const fileDownload = (href) => {
  const link = document.createElement("a");
  link.href = href;
  link.target = "_blank";
  link.click();
};

const role = () => store.getters.role;

const getRoleName = (role) => {
  const fileter = roles.filter((item) => item.role === role);

  return fileter && fileter[0] && fileter[0].name ? fileter[0].name : role;
};

const recoverByEmail = (email) => {
  store
    .dispatch("RECOVER", { email })
    .then(() => {
      if (store.getters.getErrorApi) {
        Swal.fire({
          icon: "error",
          title: "Внимание",
          text: "Эта учетная запись не активирована. Ссылка на активацию и новый пароль отправлены на почту!",
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Внимание",
          text: "Вам на почту отправлено сообщение с новым паролем.",
        });
      }
    })
    .catch((err) => {
      this.err = err;
      Swal.fire({
        icon: "error",
        title: "Ошибка",
        text: "Произошла ошибка при восстановлении пароля. Возможно такого пользователя нет в системе или он не активирован.",
      });
    });
};

Vue.prototype.sendToCalc = async (item) => {
  await sendToCalc(item);
  await getProtocoInfo();
  router.push("/calcagent");
};
Vue.prototype.setCalcByRegisterBG = async (item) => {
  await setCalcByRegisterBG(item);
  await getProtocoInfo();
  router.push("/calcagent");
};
Vue.prototype.sendToCalcResult = async (item) => {
  await sendToCalcResult(item);
  await getProtocoInfo();
  router.push("/calcreport");
};
Vue.prototype.stringToHash = stringToHash;
Vue.prototype.getUsersList = getUsersList;
Vue.prototype.cutTextLength = cutTextLength;
Vue.prototype.getRoles = getRoles;
Vue.prototype.getRoleName = getRoleName;
Vue.prototype.checkRole = checkRole;
Vue.prototype.role = role;
Vue.prototype.addProcentToTable = addProcentToTable;
Vue.prototype.getSelectedTable = getSelectedTable;
Vue.prototype.getAllTable = getAllTable;
Vue.prototype.getGarPolzZakActual = getGarPolzZakActual;
Vue.prototype.getClientSituation = getClientSituation;
Vue.prototype.session = session;
Vue.prototype.genSession = genSession;
Vue.prototype.saveReportData = saveReportData;
Vue.prototype.correctStr = correctStr;
Vue.prototype.correctNum = correctNum;
Vue.prototype.addCommas = addCommas;
Vue.prototype.removeCommas = removeCommas;
Vue.prototype.OnTextFielsFocus = (val) => val.target.select();
Vue.prototype.onChangeSumm = (value, param) =>
  store.dispatch("SET_CALC_PARAM", { param, value });
Vue.prototype.procent = procent;
Vue.prototype.calcDays = calcDays;
Vue.prototype.dateToCalendar = dateToCalendar;
Vue.prototype.calendarToDate = calendarToDate;
Vue.prototype.getNormalizeDate = getNormalizeDate;
Vue.prototype.recoverByEmail = recoverByEmail;
Vue.prototype.getAvarege = getAvarege;
Vue.prototype.CalculateAvaregeRate = CalculateAvaregeRate;
Vue.prototype.fileDownload = fileDownload;
Vue.prototype.getProtocoInfo = getProtocoInfo;
Vue.prototype.DeepCopy = DeepCopy;
Vue.prototype.getEIS = getEIS;
Vue.prototype.toBoolean = toBoolean;

(Vue.prototype.purchasesIdToSting = (purchasesId) => {
  const Purchases = store.getters.getPurchases;
  const find = Purchases.filter((item) => item.id == purchasesId);
  return find && find[0] && find[0].name ? find[0].name : "";
}),
  (Vue.prototype.quaranteesIdToString = (quaranteesId) => {
    const Quarantees = store.getters.getQuarantees;
    const find = Quarantees.filter((item) => item.id == quaranteesId);
    return find && find[0] && find[0].name ? find[0].name : "";
  }),
  (Vue.prototype.initDates = async () => {
    const date = await store.dispatch("GET_CALC_PARAM", "date");
    const date2 = await store.dispatch("GET_CALC_PARAM", "date2");

    if (!date && !date2) {
      const data = new Date();
      const y = data.getFullYear();
      const m = (data.getMonth() + 1).toString().padStart(2, "0");
      const d = data.getDate().toString().padStart(2, "0");
      store.dispatch("SET_CALC_PARAM", {
        param: "date",
        value: d + "." + m + "." + y,
      });
      store.dispatch("SET_CALC_PARAM", {
        param: "date2",
        value: "31" + "." + "01" + "." + (y + 1),
      });
      store.dispatch("SET_CALC_PARAM", {
        param: "dateConverted",
        value: dateToCalendar(store.getters.calc["date"]),
      });
      store.dispatch("SET_CALC_PARAM", {
        param: "dateConverted2",
        value: dateToCalendar(store.getters.calc["date2"]),
      });
      const days = await calcDays(
        store.getters.calc.date,
        store.getters.calc.date2
      );
      store.dispatch("SET_CALC_PARAM", {
        param: "days",
        value: days ? days : -1,
      });
    }
  }),
  (Vue.prototype.setOnlyPicker = (dateparam, calendarparam) => {
    store.dispatch("SET_CALC_PARAM", {
      param: calendarparam,
      value: dateToCalendar(store.getters.calc[dateparam]),
    });
  }),
  (Vue.prototype.setTitle = (newTitle) => {
    document.title = `${newTitle} - vmmm.ru`;
  });
Vue.prototype.onlyNumber = onlyNumber;

Vue.prototype.getBankWebsite = (banks, id) => {
  // console.log('banks,id',banks,id);
  return banks && id ? banks.filter((item) => item.id == id)[0].website : null;
};
Vue.prototype.calcBankRate = (rate) => {
  //
  let obj_name = new Array();
  let obj_desc = new Array();
  const result = new Array();
  const NewRate = new Array();
  for (let item of rate) {
    for (let row of item) {
      obj_name.push(row.name);
      obj_desc.push({ name: row.name, description: row.description });
    }
  }
  for (let [key, value] of Object.entries(obj_name)) {
    NewRate[value] = new Array();
    for (let it of rate) {
      for (let row of it) {
        if (row.name === value) {
          NewRate[value].push(row.rate);
        }
      }
    }
  }
  for (let item in NewRate) {
    const desc = obj_desc.filter((row) => row.name === item);
    result.push({
      name: item,
      rate: getAvarege(NewRate[item]),
      description:
        desc && desc.length && desc[0].description ? desc[0].description : null,
    });
  }
  return result;
};

Vue.prototype.initUserObjectRating = initUserObjectRating;

let refUrl = document.location.pathname;
const reg_calcagent = /calcagent\?winId=(\d+)/;
const reg_winId = /winId=(\d+)/;
const query =
  reg_calcagent.test(document.location.href) &&
  document.location.href.match(reg_winId)[1];
store.commit("SET_URL", "/calcagent");
localStorage.setItem("url_query", query);

if (!token || !expiration) {
  store.dispatch("clear_user");
  // store.dispatch('clearMenu');
  if (refUrl != "/" && refUrl != "/login" && refUrl != "/logout") {
    localStorage.setItem("url", refUrl);
    localStorage.setItem("url_query", query);
  } else {
    localStorage.setItem("url", "/mywins");
  }
} else {
  if (Date.now() > parseInt(expiration)) {
    store.dispatch("clear_user");
    // store.dispatch('clearMenu');
    if (refUrl != "/" && refUrl != "/login" && refUrl != "/logout") {
      localStorage.setItem("url", refUrl);
      localStorage.setItem("url_query", query);
    } else {
      localStorage.setItem("url", "/mywins");
    }
  } else {
    store.dispatch("log_in_from_cache");
    const menu = localStorage.getItem("menu");
    if (refUrl != "/" && refUrl != "/login" && refUrl != "/logout") {
      localStorage.setItem("url", refUrl);
      localStorage.setItem("url_query", query);
    } else {
      localStorage.setItem("url", "/mywins");
    }
    // const url = localStorage.getItem('url');
    // if (!menu) {
    //   // store.dispatch('getMenu');
    // } else {
    //   try {
    //     // const items = JSON.parse(menu);
    //     localStorage.setItem('url', '/mywins');
    //     // store.dispatch('setMenu', {
    //     //   items,
    //     //   url
    //     // });
    //   } catch (e) {
    //     localStorage.removeItem('menu');
    //   }
    // }
  }
}

const router = routes(store.getters.role);

store.commit("SET_MENU", router.options.menu);

router.beforeEach(async (to, from, next) => {
  //

  if (to.path == "/calcreport") {
    const calcRegisterId = to.query.calcRegisterId;
    const register =
      calcRegisterId &&
      (await store.dispatch("GET_CALC_REGISTER_BY_ID", calcRegisterId));
    await store.dispatch("SetLists");
    calcRegisterId && (await sendToCalcResult(register));
  }

  if (to.path == "/logout") {
    store.dispatch("clear_user");
    localStorage.removeItem("profile");
    store.dispatch("clearMenu");
    next({
      path: "/login",
    });
  }

  if (to.path == "/login") {
    if (store.getters.isAuthenticated) {
      next({
        path: store.getters.getMenuUrl,
      });
    } else next();
  }

  // if (to.path == "/payment") {

  // }
  if (to.matched.some((record) => record.meta.forVisitors)) {
    if (store.getters.isAuthenticated) {
      next({
        path: store.getters.getMenuUrl,
      });
    } else next();
  } else if (to.matched.some((record) => record.meta.forAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
      });
    } else next();
  } else next();
});

// window.onblur = function () {
//   // 'документ неактивен'
// }

// window.onfocus = function () {
//   // 'документ снова активен'
//   const exp = localStorage.getItem('expiration') === undefined ? undefined : localStorage.getItem('expiration') !== null && Number(localStorage.getItem('expiration'))
//   const time = + new Date()
//
//   const clear = ()=>{
//     localStorage.removeItem('token')
//     localStorage.removeItem('expiration')
//     window.Swal.fire({
//         icon: "error",
//         title: "Сеанс пользователя завершен. ",
//         text: "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново",
//     })
//     router.push('/logout')
//   }
//   exp!== null && time > exp && location.pathname !== '/logout' && clear()
// }

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
